export const RE_POSITIVE_FLOAT = new RegExp(/^\d+(\.\d+)?$/);
